export const sendAnalyticsEvent = (eventName, parameters) => {
    if (typeof gtag !== 'function') return;

    gtag('event', eventName, parameters);
}